<template>
  <div class="list-page-layout">
    <!-- 검색 툴 -->
    <search-tools v-if="showNav" v-model="nav.value" @search="onClickSearch">
      <slot name="search"></slot>
    </search-tools>

    <div class="w-full flex justify-end gap-4 text-right px-4 xl:px-0">
      <!-- 목록-->
      <div class="w-full">
        <!-- TotalLabel -->
        <div v-if="useTotalLabel" class="pl-2 xl:pl-0 mb-4 flex items-center" style="font-size: 18px">
          <span class="mr-2" style="font-weight: 700">{{ totalLabel.label }}</span>
          <span>{{ totalLabel.total }}{{ totalLabel.unit }}</span>
        </div>
      </div>
    </div>

    <!-- 테이블 -->
    <component :is="useCardBody ? 'vx-card' : 'div'" :class="{...cardBody.className}" :style="{...cardBody.style}"  component="">
      <!-- title -->
      <slot name="titles"></slot>

      <div class="w-full flex mb-4">
        <!-- SelectPerPage -->
        <div v-if="useSelectPerPage" class="flex mr-auto">
          <vs-select v-model="perPage" autocomplete class="mr-4" style="width: 110px">
            <vs-select-item v-for="v in selectPerPage.options || [10, 20, 30, 50]" :text="`${v}개씩 보기`" :value="v" />
          </vs-select>
        </div>
        <div class="flex ml-auto ">
          <slot name="buttons" :func="{}"></slot>
        </div>
      </div>

      <slot></slot>

      <!--페이지네이션-->
      <div v-if="usePagination" class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination :total="pagination.lastPage" :max-items="pagination.maxItems" v-model="page" @change="onChangePage"></k-pagination>
        </div>
      </div>
    </component>
  </div>
</template>

<script>
/* eslint-disable */
import SearchNav from "@/components/nav/SearchNav";
import KPagination from "@/components/kPagination/kPagination";
import SearchTools from "@/views/list/components/SearchTools.vue";
import singlePageList from "@/views/boards/single-page/listIndex";

export default {
  name: "ListPageLayout",
  components: {
    SearchTools,
    KPagination,
    SearchNav,
  },
  props: {
    // 검색툴 사용 여부
    showNav: {
      type: Boolean,
      default: true,
    },
    // 결재문서인지 여부
    approval: false,

    // 목록 표기 이외 설정들
    options: {
      type: Object,
      default: () => ({

      }),
    },

    // 추가 옵션
    /** ===== useCardBody ===== */
    useCardBody: {
      type: Boolean,
      default: true,
    },
    cardBody: {
      type: Object,
      default: () => ({
        'className': '표시된 문서 : ',
        'style': '건',
      }),
    },

    /** ===== useTotalLabel ===== */
    useTotalLabel: Boolean,
    totalLabel: {
      type: Object,
      default: () => ({
        'label': '표시된 문서 : ',
        'unit': '건',
        'total': 0,
      }),
    },

    /** ===== useSelectPerPage ===== */
    useSelectPerPage: Boolean,
    selectPerPage: {
      type: Object,
      default: () => ({
        'options': [10, 20, 50, 100],
        'unit': '건',
      }),
    },

    /** ===== usePagination ===== */
    usePagination: {
      type: Boolean,
      default: true,
    },
    pagination: {
      type: Object,
      default: () => ({
        'lastPage': 1,
        'maxItems': 5,
        'default': 1,
      }),
    },
  },

  watch: {
    perPage() {
      this.loadList();
    },
  },

  data() {
    return {
      nav: {
        value: {},
      },
      page: this.usePagination ? this.pagination.default : 1,
      perPage: this.useSelectPerPage ? this.selectPerPage.default : 10,
    };
  },
  async created() {

  },
  mounted() {

  },
  methods: {

    // 목록을 불러오는 함수
    loadList() {
      const func = {
        getConditions: this.getConditions,
      }
      const { page, perPage } = this
      this.$emit("load", { page, perPage, search: this.nav.value, func })
    },

    // 인자로 받은 boardId에 해당하는 리스트의 검색 조건을 반환 (List.js 의 getConditions 함수를 호출)
    getConditions(boardId) {
      const func = singlePageList[`${boardId}_list`] && singlePageList[`${boardId}_list`].getConditions;
      if (func) {
        return func(this.nav);
      }
      return [];
    },

    onClickSearch() {
      this.page = 1;
      this.$emit('search')
      this.loadList();
    },
    onChangePage(page) {
      this.page = page;
      this.loadList();
      if (this.pagination.change) {
        this.pagination.change(page, this.perPage)
      }
    },
    setPage(page) {
      this.page = page;
    },
  },
};
</script>

<style lang="scss" scoped>
.list-page-layout {

}
</style>
